import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  init() {
    this.hours = this.el.querySelector('[data-opening-hours]')
    this.day = this.el.querySelector('[data-opening-day]')
    this.who = this.el.querySelector('[data-opening-who]')
    this.label = this.el.querySelector('[data-opening-label]')
    this.sign = this.el.querySelector('[data-opening-sign]')
    this.name = (this.label || this.who).textContent.trim()

    this.lang = document.documentElement.lang
    this.open = 'OPEN'
    this.closed = 'CLOSED'

    switch (this.lang) {
      case 'nl-BE':
        this.open = 'OPEN'
        this.closed = 'GESLOTEN'
        break
      case 'en-GB':
        this.open = 'OPEN'
        this.closed = 'CLOSED'
        break
      case 'fr-BE':
        this.open = 'OUVERT'
        this.closed = 'FERMÉ'
        break
    }

    if (this.label) {
      this.label.textContent = this.name
    }

    this.refresh()
    setInterval(() => {
      this.refresh()
    }, 60000)
  }

  check() {
    const now = new Date()
    const formattedDD = now.getDate().toString().padStart(2, '0')
    const formattedMM = (now.getMonth() + 1).toString().padStart(2, '0')
    const formattedYYYY = now.getFullYear()
    const formattedNow = `${formattedDD}/${formattedMM}/${formattedYYYY}`

    const parseTime = (timeString) => {
      if (!timeString) return null
      const [time, meridiem] = timeString.split(' ')
      const [rawHours, rawMinutes] = time.split(':')
      let hours = parseInt(rawHours, 10)
      const minutes = parseInt(rawMinutes, 10)

      if (meridiem) {
        const normalized = meridiem.toLowerCase()
        if (normalized === 'pm' && hours !== 12) hours += 12
        if (normalized === 'am' && hours === 12) hours = 0
      }

      return { hours, minutes }
    }

    const exceptionDay = (window.exceptionDays || []).find(
      (obj) => obj.date === formattedNow
    )

    if (exceptionDay) {
      const exceptionStart = parseTime(exceptionDay.hour_start)
      const exceptionEnd = parseTime(exceptionDay.hour_end)

      if (!exceptionStart || !exceptionEnd) {
        this.state = false
        return
      }

      const start = new Date()
      start.setHours(exceptionStart.hours)
      start.setMinutes(exceptionStart.minutes)

      const end = new Date()
      end.setHours(exceptionEnd.hours)
      end.setMinutes(exceptionEnd.minutes)

      this.state = now >= start && now <= end
      return
    }

    const isClosedDay = (window.closedDays || []).some(
      (obj) => obj.day === formattedNow
    )

    if (isClosedDay) {
      this.state = false
      return
    }

    const day = now.getDay() - 1 === -1 ? 6 : now.getDay() - 1
    const openings = window.openings[day]

    if (openings) {
      const defaultStart = parseTime(openings.hour_start)
      const defaultEnd = parseTime(openings.hour_end)

      if (!defaultStart || !defaultEnd) {
        this.state = false
        return
      }

      const start = new Date()
      start.setHours(defaultStart.hours)
      start.setMinutes(defaultStart.minutes)

      const end = new Date()
      end.setHours(defaultEnd.hours)
      end.setMinutes(defaultEnd.minutes)

      this.state = now >= start && now <= end
      return
    }

    this.state = false
  }

  refresh() {
    const date = new Date()
    const hours = date.getHours()
    const minutes = date.getMinutes()
    const day = date.getDate()
    const month = date.getMonth() + 1

    this.hours.innerHTML = `${hours}:${minutes < 10 ? `0${minutes}` : minutes}`
    this.day.innerHTML = `${day < 10 ? `0${day}` : day}.${month < 10 ? `0${month}` : month}`

    this.check()

    const statusText = this.state ? this.open : this.closed

    if (this.sign) {
      this.sign.textContent = statusText
    } else if (this.label) {
      this.label.textContent = `${this.name} ${statusText}`
    } else {
      this.who.textContent = `${this.name} ${statusText}`
    }

    this.who.classList.toggle('is-open', !!this.state)
    this.who.classList.toggle('is-closed', !this.state)
  }
}
